import type { Project } from '../../../core/model';
import type { Registry } from '../../../core/registry';
import type { RuntimeState } from '../../../engine/api';

/** "id:kind" pairs joined into one primitive, so a selector returning it is stable. */
export const sourceKindsKey = (project: Project): string =>
  Object.values(project.sources)
    .map((s) => `${s.id}:${s.kind}`)
    .join('|');

export const liveAudioKey = (runtime: RuntimeState): string =>
  Object.keys(runtime.sources)
    .filter((id) => runtime.sources[id]?.hasAudio)
    .join('|');

/** Sources that get a mixer strip: live audio reported by the runtime, or an audio-capable type. */
export function audioSourceIds(kindsKey: string, liveKey: string, registry: Pick<Registry, 'getSource'>): string[] {
  if (!kindsKey) return [];
  const live = new Set(liveKey ? liveKey.split('|') : []);
  const ids: string[] = [];
  for (const pair of kindsKey.split('|')) {
    const split = pair.indexOf(':');
    const id = pair.slice(0, split);
    const kind = pair.slice(split + 1);
    if (live.has(id) || registry.getSource(kind)?.caps.audio) ids.push(id);
  }
  return ids;
}
